import { cx } from "class-variance-authority";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useTranslation } from "react-i18next";

import { LogoIcon } from "@/assets/icons/navbar/Logo";
import { UserDropdown } from "@/components/shared/layout/UserDropdown";
import { Typography } from "@/components/ui/text/Typography/Typography";
import { RouteConfig } from "@/config/route.config";

const tabs = [
  {
    id: "dashboard",
    label: "ui.navbar.dashboard",
    href: RouteConfig.home,
  },
  {
    id: "profiles",
    label: "ui.navbar.profiles",
    href: RouteConfig.uploads,
  },
];

export const Header = () => {
  const pathname = usePathname();
  const { t } = useTranslation();

  const isActive = (href: string) => pathname === href;

  return (
    <div className="flex h-[60px] items-center justify-between border-elevation-outline-2 border-b bg-elevation-surface-1 pr-5 text-text-default-primary">
      <div className="flex items-center">
        <div className="flex h-[60px] items-center gap-2 border-elevation-outline-2 border-r pr-12">
          <LogoIcon className="h-12" />
        </div>
        <div className="flex flex-row items-center">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className="flex h-[60px] items-center border-elevation-outline-2 border-r px-10 last:border-r-0"
            >
              <Link href={tab.href}>
                <Typography
                  className={cx("text-text-inverted-secondary", isActive(tab.href) && "!text-text-default-primary")}
                  size="body-2"
                  variant={isActive(tab.href) ? "prominent-2" : "default"}
                >
                  {t(tab.label as any)}
                </Typography>
              </Link>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center gap-2">
        <UserDropdown />
      </div>
    </div>
  );
};
